"use client"
import {UseFormRegisterReturn} from "react-hook-form"
import {useState} from "react"

type TextareaProps = {
    label: string
    id: string
    className?: string
    placeholder?: string
    required: boolean
    max: number
    registration: Partial<UseFormRegisterReturn>
}

const Textarea = (Props:TextareaProps) => {
    const [count,setCount] = useState(0)

    return(
        <div>
            <label htmlFor={Props.id} className={"flex items-center"}>{Props.label}{Props.required && (<span className={"ml-2 text-xs text-danger"}>必須</span>)}</label>
            <textarea
                name={Props.id}
                id={Props.id}
                className={"block w-full mt-22 min-h-[120px] border rounded-lg p-2 focus:ring-blue-500 focus:border-blue-500"}
                maxLength={Props.max}
                {...Props.registration}
                onChange={e => {setCount(e.target.value.length)}}
            />
            <p className={"text-right text-gray text-xs mt-1"}>{count}/{Props.max}</p>
        </div>
    )
}

export default Textarea